import api from './api';

// Documents des demandes Support & Innovation (stockés sur S3, comme Litiges).
// Même contrat que litige-documents pour réutiliser le composant partagé DocumentSection.
const supportInnovationDocsApi = {
  getAll: (requestId) => api.get(`/support-innovation/${requestId}/documents`),

  presign: (requestId, { filename, contentType }) =>
    api.post(`/support-innovation/${requestId}/documents/presign`, { filename, contentType }),

  confirm: (requestId, { key, filename, contentType, size }) =>
    api.post(`/support-innovation/${requestId}/documents/confirm`, { key, filename, contentType, size }),

  uploadFile: (requestId, formData) =>
    api.post(`/support-innovation/${requestId}/documents/upload-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  rename: (requestId, docId, nom) =>
    api.patch(`/support-innovation/${requestId}/documents/${docId}`, { nom }),

  delete: (requestId, docId) =>
    api.delete(`/support-innovation/${requestId}/documents/${docId}`),
};

export default supportInnovationDocsApi;
